import { useContext, useMemo } from 'react';

import { Label } from '@smartshell/ui-kit';
import { Column } from 'react-table';

import { ClientsAvatar } from 'components';
import { LocalizationContext } from 'localization';

import s from './Bonus.module.scss';
import { INormalizedItem } from './interfaces';

export const useColumns = (): Array<Column<INormalizedItem>> => {
  const { t } = useContext(LocalizationContext);

  return useMemo<Array<Column<INormalizedItem>>>(
    () => [
      {
        Header: t('clients'),
        accessor: 'client',
        Cell: ({ value }: { value: INormalizedItem['client'] }) => (
          <div className={s.client}>
            <ClientsAvatar
              avatar={value?.avatar_url}
              roles={value?.isWorker ? [{ alias: 'operator' }] : []}
              size="s"
            />
            <div className={s.client_info}>
              <span>{value?.nickname ? value?.nickname : value?.phone}</span>
              <span className={s.phone}>{value?.phone}</span>
            </div>
          </div>
        ),
        width: 300,
      },
      {
        Header: t('direct.replenishment'),
        accessor: 'renewal',
        Cell: ({ value }: { value: number }) => value,
        width: 130,
      },
      {
        Header: t('visitors.cashback'),
        accessor: 'cashback',
        Cell: ({ value }: { value: number }) => value,
        width: 120,
      },
      {
        Header: t('key.bonus_achievement'),
        accessor: 'achievements',
        Cell: ({ value }: { value: number }) => value,
        width: 120,
      },
      {
        Header: t('promoCode'),
        accessor: 'promocode',
        Cell: ({ value }: { value: number }) => value,
        width: 120,
      },
      {
        Header: t('accrued'),
        accessor: 'accrued',
        Cell: ({ value }: { value: number }) => (
          <Label color="blue" iconName="BonusAddIcon" text={String(value)} />
        ),
        width: 120,
      },
      {
        Header: t('waste'),
        accessor: 'waste',
        Cell: ({ value }: { value: number }) => (
          <Label
            color="orange"
            iconName="BonusRemoveIcon"
            text={String(value)}
          />
        ),
        width: 120,
      },
    ],
    [t]
  );
};
